import { useState } from "react";

import { Grid, ButtonBase, useTheme } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";

import PortfolioCard from "./PortfolioCard";

import GrayPaper from "../../atoms/GrayPaper";

const OffsetBucketButton = ({
  portfolio,
  onClick,
  setShowPortfolioDetails,
  isSelected,
}) => {
  const theme = useTheme();

  const [hover, setHover] = useState(false);

  return (
    <ButtonBase
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: "100%",
        height: "100%",
        textAlign: "left",
        position: "relative",
      }}
    >
      <PortfolioCard
        portfolio={portfolio}
        isSelected={isSelected}
        hover={hover}
        setShowPortfolioDetails={setShowPortfolioDetails}
      />
      {isSelected && (
        <div style={{ top: -5, left: -5, position: "absolute" }}>
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{ color: theme.palette.secondary.main }}
            size="2x"
          />
        </div>
      )}
    </ButtonBase>
  );
};

const CnaughtOffsetsDisplayBlock = ({
  cNaughtPortfolios,
  selectedOffsetBucketIdx,
  setSelectedOffsetBucketIdx,
  setShowPortfolioDetails,
}) => {
  return (
    <GrayPaper>
      <Grid container spacing={2} justifyContent="center">
        {cNaughtPortfolios.map((portfolio, idx) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={cNaughtPortfolios.length < 3 ? 6 : 3}
            key={idx}
          >
            <OffsetBucketButton
              isSelected={idx === selectedOffsetBucketIdx}
              portfolio={portfolio}
              onClick={
                setSelectedOffsetBucketIdx
                  ? () => setSelectedOffsetBucketIdx(idx)
                  : () => setShowPortfolioDetails(portfolio)
              }
              setShowPortfolioDetails={setShowPortfolioDetails}
            />
          </Grid>
        ))}
      </Grid>
    </GrayPaper>
  );
};
export default CnaughtOffsetsDisplayBlock;
